import { FC } from "react";

const ICONS: Record<string, JSX.Element> = {
  flame: (
    <path
      fill="currentColor"
      d="M12.8 2.2c.4 3-1 4.8-2.4 6.4C9 10.2 7.6 11.8 7.6 14.3c0 1 .3 1.9.8 2.7-1.9-.8-3.2-2.8-3.2-5.1 0 2.3-.8 3.4-.8 5 0 3.9 3.4 6.9 7.6 6.9s7.8-3 7.8-7.2c0-4.3-2.9-6.2-3.6-9.4-.2 1.4-.8 2.5-1.7 3.2.4-3.3-.4-6.1-1.7-8.2zM12 21.2c-1.9 0-3.2-1.3-3.2-3 0-2 1.7-2.8 2.4-4.8 1 1.2 3.9 2.2 3.9 4.8 0 1.7-1.3 3-3.1 3z"
    />
  ),
  eye: (
    <path
      fill="currentColor"
      d="M12 5C6.5 5 2.4 8.6 1 12c1.4 3.4 5.5 7 11 7s9.6-3.6 11-7c-1.4-3.4-5.5-7-11-7zm0 11.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-7a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
    />
  ),
  shield: (
    <path
      fill="currentColor"
      d="M12 1.8 3.5 5v6.2c0 5.4 3.6 10.3 8.5 11.6 4.9-1.3 8.5-6.2 8.5-11.6V5L12 1.8zm0 2.1 6.5 2.5v4.8c0 4.3-2.7 8.4-6.5 9.6V3.9z"
    />
  ),
  play: <path fill="#fff" d="M7 4.5v15l12.5-7.5z" />,
  arrow: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 12h15m-6-6 6 6-6 6"
    />
  ),
  caret: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6 9 6 6 6-6"
    />
  ),
  pin: (
    <path
      fill="currentColor"
      d="M12 2a7 7 0 00-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 00-7-7zm0 9.5A2.5 2.5 0 1112 6.5a2.5 2.5 0 010 5z"
    />
  ),
  cert: (
    <path
      fill="currentColor"
      d="M12 2l2.4 1.8 3-.1.9 2.9 2.4 1.8-1 2.8 1 2.8-2.4 1.8-.9 2.9-3-.1L12 20.4l-2.4-1.8-3 .1-.9-2.9-2.4-1.8 1-2.8-1-2.8 2.4-1.8.9-2.9 3 .1L12 2zm-1.2 12.6 5-5-1.4-1.4-3.6 3.6-1.7-1.7-1.4 1.4 3.1 3.1z"
    />
  ),
  search: (
    <path
      fill="currentColor"
      d="M10.5 3a7.5 7.5 0 015.9 12.1l4.8 4.8-1.4 1.4-4.8-4.8A7.5 7.5 0 1110.5 3zm0 2a5.5 5.5 0 100 11 5.5 5.5 0 000-11z"
    />
  ),
  mail: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinejoin="round"
      d="M3 5.5h18v13H3zM3.5 6l8.5 7 8.5-7"
    />
  ),
  heart: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
      d="M12 20s-7.5-4.6-9-9.4C2 7.4 4.2 4.5 7.3 4.5c2 0 3.4 1.1 4.7 2.8 1.3-1.7 2.7-2.8 4.7-2.8 3.1 0 5.3 2.9 4.3 6.1-1.5 4.8-9 9.4-9 9.4z"
    />
  ),
  attn: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c.8-4 4-6.5 8-6.5s7.2 2.5 8 6.5" />
    </g>
  ),
  people: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="8" r="3.2" />
      <circle cx="5" cy="10" r="2.3" />
      <circle cx="19" cy="10" r="2.3" />
      <path d="M6.5 20c.6-3.4 2.8-5.3 5.5-5.3s4.9 1.9 5.5 5.3M1.5 19c.3-2.3 1.6-3.7 3.5-3.9M22.5 19c-.3-2.3-1.6-3.7-3.5-3.9" />
    </g>
  ),
  grad: (
    <path
      fill="currentColor"
      d="M12 3 1 9l11 6 9-4.9V17h2V9L12 3zm-6 9.9v3.7c0 1.9 2.7 3.4 6 3.4s6-1.5 6-3.4v-3.7l-6 3.3-6-3.3z"
    />
  ),
  tool: (
    <path
      fill="currentColor"
      d="M9 3h6v2h5a1 1 0 011 1v4H3V6a1 1 0 011-1h5V3zm2 2h2V5h-2zM3 12h7v2h4v-2h7v7a1 1 0 01-1 1H4a1 1 0 01-1-1v-7z"
    />
  ),
  ext: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 4h6v6M20 4l-9 9M18 14v5H5V6h5"
    />
  ),
  extinguisher: (
    <path
      fill="currentColor"
      d="M9 2h4v2h2.5L19 2v4l-3.5-1.5H14v2.1A4.5 4.5 0 0117 11v10a1 1 0 01-1 1H8a1 1 0 01-1-1V11a4.5 4.5 0 013-4.4V4H9V2zm-.5 11v3h7v-3h-7z"
    />
  ),
  ladder: (
    <path
      fill="currentColor"
      d="M7 2h2v2h6V2h2v20h-2v-2H9v2H7V2zm2 4v3h6V6H9zm0 5v3h6v-3H9zm0 5v2h6v-2H9z"
    />
  ),
  in: (
    <path
      fill="currentColor"
      d="M4.5 3.5a2 2 0 110 4 2 2 0 010-4zM3 9h3v12H3zM9 9h2.9v1.7c.5-.9 1.7-2 3.6-2 3.7 0 4.5 2.4 4.5 5.6V21h-3v-5.9c0-1.4 0-3.2-2-3.2s-2.3 1.5-2.3 3.1v6H9z"
    />
  ),
  ig: (
    <path
      fill="currentColor"
      d="M12 7.3a4.7 4.7 0 110 9.4 4.7 4.7 0 010-9.4zm0 7.6a2.9 2.9 0 100-5.8 2.9 2.9 0 000 5.8zM17.2 5.6a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2zM12 2c2.7 0 3 0 4.1.1 3.1.1 4.6 1.6 4.7 4.7.1 1.1.1 1.4.1 4.1s0 3-.1 4.1c-.1 3.1-1.6 4.6-4.7 4.7-1.1.1-1.4.1-4.1.1s-3 0-4.1-.1c-3.1-.1-4.6-1.6-4.7-4.7C3.1 15 3 14.7 3 12s0-3 .1-4.1C3.2 4.8 4.7 3.3 7.8 3.2 8.9 2 9.3 2 12 2zm0 1.8c-2.6 0-2.9 0-4 .1-2.2.1-3.2 1.1-3.3 3.3-.1 1-.1 1.3-.1 3.9s0 2.9.1 4c.1 2.2 1.1 3.2 3.3 3.3 1 .1 1.4.1 4 .1s2.9 0 4-.1c2.2-.1 3.2-1.1 3.3-3.3.1-1 .1-1.4.1-4s0-2.9-.1-3.9c-.1-2.2-1.1-3.2-3.3-3.3-1-.1-1.4-.1-4-.1z"
    />
  ),
  yt: (
    <path
      fill="currentColor"
      d="M22.5 7.2a2.8 2.8 0 00-2-2C18.8 4.8 12 4.8 12 4.8s-6.8 0-8.5.4a2.8 2.8 0 00-2 2A29 29 0 001.2 12c0 1.6.1 3.3.3 4.8a2.8 2.8 0 002 2c1.7.4 8.5.4 8.5.4s6.8 0 8.5-.4a2.8 2.8 0 002-2c.2-1.5.3-3.2.3-4.8s-.1-3.3-.3-4.8zM9.9 15.1V8.9l5.6 3.1-5.6 3.1z"
    />
  ),
  menu: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      d="M4 7h16M4 12h16M4 17h16"
    />
  ),
};

export type IconName = keyof typeof ICONS;

interface IconProps {
  name: IconName;
  className?: string;
}

const Icon: FC<IconProps> = ({ name, className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    {ICONS[name]}
  </svg>
);

export default Icon;
